export default __webpack_public_path__ + "static/media/3.add8fc59.svg";